import moment, {Moment} from "moment";

export class DateRangeUpdateVO {
  dateRange: DateRange | null;
  from: string | null;
  to: string | null;

  constructor(dateRange: DateRange | null, from: string | null, to: string | null) {
    this.dateRange = dateRange;
    this.from = from;
    this.to = to;
  }
}

export class DateRangeVO {
  from: Moment;
  to: Moment;

  constructor(from: Moment, to: Moment) {
    this.from = from;
    this.to = to;
  }
}

export enum DateRange {
  LAST_TWO_WEEKS,
  NEXT_TWO_WEEKS,
  CURRENT_MONTH,
  LAST_MONTH,
  CURRENT_YEAR,
  LAST_YEAR
}

export type I18nCallback = (i18n: string) => string;

export default {
  dateText(t: I18nCallback, dateRange: DateRange | null, from: string | null, to: string | null): string {
    switch (dateRange) {
      case DateRange.LAST_TWO_WEEKS:
        return t("date.dateRange.lastTwoWeeks");
      case DateRange.NEXT_TWO_WEEKS:
        return t("date.dateRange.nextTwoWeeks");
      case DateRange.CURRENT_MONTH:
        return t("date.dateRange.currentMonth");
      case DateRange.LAST_MONTH:
        return t("date.dateRange.lastMonth");
      case DateRange.CURRENT_YEAR:
        return t("date.dateRange.currentYear");
      case DateRange.LAST_YEAR:
        return t("date.dateRange.lastYear");
      default:
        if (!from || !to) {
          return "";
        } else {
          return moment(from).format("DD.MM.YY") + "-" + moment(to).format("DD.MM.YY");
        }
    }
  },
  getDates(dateRange: DateRange): DateRangeVO {
    let from = moment();
    let to = moment();

    switch (dateRange) {
      case DateRange.LAST_TWO_WEEKS:
        from = moment().subtract(14, "days");
        break;
      case DateRange.NEXT_TWO_WEEKS:
        to = moment().add(14, "days");
        break;
      case DateRange.CURRENT_MONTH:
        from = moment().startOf("month");
        to = moment().endOf("month");
        break;
      case DateRange.LAST_MONTH:
        from = moment().subtract(1, "month").startOf("month");
        to = moment().subtract(1, "month").endOf("month");
        break;
      case DateRange.CURRENT_YEAR:
        from = moment().startOf("year");
        to = moment().endOf("year");
        break;
      case DateRange.LAST_YEAR:
        from = moment().subtract(1, "years").startOf("year");
        to = moment().subtract(1, "years").endOf("year");
        break;
    }

    return new DateRangeVO(from, to);
  }
};
